import React, { useState } from "react";
import { useLikeProperty } from "../../../hooks/react-query/properties/useLikeProperty";
import { useUnLikeProperty } from "../../../hooks/react-query/properties/useUnLikeProperty";
// import { useLocation, useNavigate } from "react-router-dom";
import styles from "./like.module.scss";
import useContextHook from "../../../hooks/context/useContext";
import { LikedProperty, unLikedProperty } from "../../investor/amplitude";

interface LikeProps {
  propertyId: string;
  favCount: number;
  isMobile?: boolean;
  refetch?: () => void;
  width?: number;
  className?: string;
  totalCount?: number;
  currentPageItemCount?: number;
  isSavedProperty?: boolean;
  loginType: string;
  objPropertyDetails: any;
}

const Like: React.FC<LikeProps> = ({
  propertyId,
  favCount,
  isMobile = false,
  refetch,
  width = 24,
  className,
  // totalCount,
  // currentPageItemCount,
  isSavedProperty = false,
  loginType,
  objPropertyDetails
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentFavCount, setCurrentFavCount] = useState(favCount);
  const { mobileNumber } = useContextHook();
  const mobileNumber1 = localStorage.getItem("mobileNumber") || "";
  // const navigate = useNavigate();
  // const location = useLocation();

  const { likeProperty } = useLikeProperty(
    loginType,
    () => {
      setIsLoading(false);
      setCurrentFavCount(1);
      if (loginType === "investor") {
        LikedProperty({
          propertyId: objPropertyDetails?.id,
          propertySFID: objPropertyDetails?.propertySFID,
          opportunitySFID: objPropertyDetails?.opportunitySFID,
          pubPropertySFID: objPropertyDetails?.pubPropertySFID,
          mobileNumber: mobileNumber || mobileNumber1,
          shareId: objPropertyDetails?.shareKey,
          address: objPropertyDetails?.address,
          bedRooms: objPropertyDetails?.bedRooms,
          baths: objPropertyDetails?.baths,
          sqft: objPropertyDetails?.sqft,
          askingPrice: objPropertyDetails?.askingPrice
        });
      }
    },
    () => setIsLoading(false)
  );

  const { unLikeProperty } = useUnLikeProperty(
    loginType,
    async () => {
      setIsLoading(false);
      setCurrentFavCount(0);
      if (loginType === "investor") {
        unLikedProperty({
          propertyId: objPropertyDetails?.id,
          propertySFID: objPropertyDetails?.propertySFID,
          opportunitySFID: objPropertyDetails?.opportunitySFID,
          pubPropertySFID: objPropertyDetails?.pubPropertySFID,
          mobileNumber: mobileNumber || mobileNumber1,
          shareId: objPropertyDetails?.shareKey,
          address: objPropertyDetails?.address,
          bedRooms: objPropertyDetails?.bedRooms,
          baths: objPropertyDetails?.baths,
          sqft: objPropertyDetails?.sqft,
          askingPrice: objPropertyDetails?.askingPrice
        });
      }
      if (isSavedProperty) {
        // Force refetch for saved properties to ensure list is up to date
        if (refetch) {
          await refetch();
        }
      }
    },
    () => setIsLoading(false)
  );

  const handleLike = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsLoading(true);
    await likeProperty(e, propertyId, "");
    if (refetch) {
      refetch();
    }
  };

  const handleUnlike = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsLoading(true);
    await unLikeProperty(e, propertyId);

    // For saved properties, we don't need to update local state
    // as the component will be removed from the list
    if (!isSavedProperty) {
      if (refetch) {
        refetch();
      }
    }
  };

  if (isLoading) {
    return (
      <div
        className={`${styles.like} ${styles.loading} ${className}`}
        style={{ width: `${width}px`, height: `${width}px` }}
      >
        <div className={styles.spinner}></div>
      </div>
    );
  }

  return (
    <img
      src={
        currentFavCount > 0
          ? isMobile
            ? "/images/mobile-like.svg"
            : "/images/likeCard.svg"
          : isMobile
          ? "/images/mobile-unlike.svg"
          : "/images/un-like.svg"
      }
      alt=""
      width={width}
      onClick={currentFavCount > 0 ? handleUnlike : handleLike}
      className={`${styles.like} ${className}`}
    />
  );
};

export default Like;
